import { Component, inject } from '@angular/core';
import { IExamViewModel } from '../../../api/exam-view-model.model';
import { IQuestionCategories } from '../../shared/models/question-categories';
import { AvailableExamsService } from '../../../api/api-services/available-exams.service';
import { GetQuestionCategoriesService } from '../../shared/api/get-question-categories.service';
import { QuestionDatabaseDataService } from './question-database-data.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-question-database',
  templateUrl: './question-database.component.html',
  styleUrl: './question-database.component.scss'
})
export class QuestionDatabaseComponent {
  
  private _questionDatabaseDataService = inject(QuestionDatabaseDataService);
  private _getQuestionCategories = inject(GetQuestionCategoriesService);
  private _availableExamsService = inject(AvailableExamsService);
  private _messageService = inject(MessageService);


  ngOnInit(): void {
    this.loadQuestionCategories();
    this.loadAvailableExams();
  }

  private loadAvailableExams(): void {
    this._availableExamsService.get().subscribe({
      next: (exams) => {
        this._questionDatabaseDataService.availableExams.set(exams)
      },
      error: (error) => {
        console.error('Error loading available exams:', error);
        this._messageService.add({
          severity: 'error',
          summary: 'Błąd',
          detail: 'Nie udało się załadować kategorii egzaminów'
        });
      }
    });
  }

  private loadQuestionCategories(): void {
    this._getQuestionCategories.getQuestionsCategories$().subscribe({
      next: (response) => {
        if (Array.isArray(response)) {
          this._questionDatabaseDataService.questionCategories.set(response);
        } else {
          this._questionDatabaseDataService.questionCategories.set([response]);
        }
      },
      error: (error) => {
        console.error('Error loading question categories:', error);
        this._messageService.add({
          severity: 'error',
          summary: 'Błąd',
          detail: 'Nie udało się załadować kategorii pytań'
        });
      }
    });
  }
  
}
